const getEquipmentHistoryUseCase = (repository) => async (id) => {
    return await repository(id);
}

export default getEquipmentHistoryUseCase;